<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5596 15.4584L14.15 12.0443C14.9834 10.8114 15.457 9.33193 15.457 7.73867C15.457 3.47102 11.9905 0 7.72849 0C3.46646 0 0 3.47102 0 7.73867C0 12.0063 3.46646 15.4584 7.72849 15.4584C9.31965 15.4584 10.7972 14.9652 12.0284 14.1496L15.438 17.5638C15.7222 17.8483 16.12 18 16.4988 18C16.8777 18 17.2565 17.8483 17.5596 17.5638C18.1468 16.9947 18.1468 16.0464 17.5596 15.4584ZM8.61878 8.63014V10.5838C8.61878 11.0769 8.22099 11.4752 7.72849 11.4752C7.23599 11.4752 6.8382 11.0769 6.8382 10.5838V8.63014H4.86819C4.37569 8.63014 3.9779 8.23182 3.9779 7.73867C3.9779 7.24552 4.37569 6.84721 4.86819 6.84721H6.81926V4.8746C6.81926 4.38145 7.21705 3.98314 7.70955 3.98314C8.20205 3.98314 8.59984 4.38145 8.59984 4.8746V6.82824H10.5509C11.0434 6.82824 11.4412 7.22655 11.4412 7.7197C11.4412 8.21286 11.0624 8.63014 10.5698 8.63014H8.61878Z"
    />
  </svg>
</template>
